module.exports = __webpack_public_path__ + "static/media/sg12tj1023.7690012c.png";